import Axios from "./axios.service";

export const getOpenBalance = (payload) => {
  return Axios({
    method: "GET",
    url: `web-services/api/v6/services/report/opening-balance/reports?page=1&size=15&fromDate=${payload?.from}&toDate=${payload.to}&currency-code=${payload.currencyCode}&actionType=${payload.openAction}`,
  });
};

export const listCashierOpeningBalance = () => {
  return Axios({
    method: "GET",
    url: `web-services/api/v6/services/report/cashier-opening/reports?page=1&size=15`,
  });
};
